import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { Link } from "react-router-dom";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import footerMiddleData from "../../components/shared/footer/FooterMiddle.json";
import footerBottomData from "../../components/shared/footer/FooterBottom.json";
import footerTopData from "../../components/shared/footer/FooterTopData.json";

const Sitemap = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const getPath = (path) => {
    const segments = path.split("/");
    if (segments[1] === "neepco") {
      return "/" + segments.slice(2).join("/");
    }
    return path;
  };

  const {
    data: ṃenus = {},
    isLoading,
    isError,
  } = useGetProtectedApiDataQuery({
    url: "mastermenu",
    lang: languageType,
  });

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Sitemap", "साइट मैप")}
        titleLink="/screen-reader"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Sitemap", "साइट मैप")}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <div className="row">
              <div className="container important-links">
                <ul className="inn_list list_cstar sitemap-list">
                  {/* menus */}
                  {isLoading && (
                    <li>
                      {getText("Loading menus...", "मेनू लोड हो रहे हैं...")}
                    </li>
                  )}
                  {isError && (
                    <li>
                      {getText(
                        "Unable to load menus. Please try again later.",
                        "मेनू लोड नहीं हो सके। कृपया बाद में पुनः प्रयास करें।",
                      )}
                    </li>
                  )}
                  {ṃenus?.menu_items?.map((item, index) => (
                    <li className="expanded" key={index}>
                      {item.submenu &&
                      getPath(item.url) !== "/power-generation" ? (
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          {item.title}
                        </a>
                      ) : (
                        <Link to={getPath(item.url)}>{item.title}</Link>
                      )}
                      {item.submenu && (
                        <ul className="site-map-menu mt-2">
                          {item.submenu.map((subitem, subIndex) => (
                            <li className="first leaf" key={subIndex}>
                              <Link to={getPath(subitem.url)}>
                                {subitem.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}

                  {/* footer top menus */}
                  {footerTopData.map((item, index) => (
                    <li className="leaf" key={index}>
                      <Link
                        to={item.link}
                        style={{ textTransform: "capitalize" }}
                      >
                        {item.title === "RTI"
                          ? "RTI"
                          : getText(item.title, item.translation).toLowerCase()}
                      </Link>
                    </li>
                  ))}

                  {/* footer middle menus */}
                  {footerMiddleData.map((item, index) => (
                    <li className="leaf" key={index}>
                      {item.link.startsWith("https") ? (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getText(item.title, item.translation)}
                        </a>
                      ) : (
                        <Link to={item.link}>
                          {getText(item.title, item.translation)}
                        </Link>
                      )}
                    </li>
                  ))}

                  {/* footer bottom menus */}
                  {footerBottomData.map((item, index) => (
                    <li className="leaf" key={index}>
                      <Link to={item.link}>
                        {getText(item.title, item.translation)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sitemap;
